/* eslint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TInfiniteSearchForMobileSiteRequest,
  TInfiniteSearchForMobileSiteModel,
  IMappers,
  TInfiniteSearchForMobileSiteResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IInfiniteSearchForMobileSiteResponseSchema } from '../../entities/response/InfiniteSearchForMobileSiteResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createInfiniteSearchForMobileSiteModel(
  parameters: TInfiniteSearchForMobileSiteRequest,
): TInfiniteSearchForMobileSiteModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-engine',
    pathApi: '/v1/infinite-search-for-mobile-site/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IInfiniteSearchForMobileSiteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TInfiniteSearchForMobileSiteRequest;
}

export async function fetchInfiniteSearchForMobileSite<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IInfiniteSearchForMobileSiteOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TInfiniteSearchForMobileSiteResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createInfiniteSearchForMobileSiteModel(parameters),
    config,
  )) as FetchResponse<TInfiniteSearchForMobileSiteResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IInfiniteSearchForMobileSiteResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TInfiniteSearchForMobileSiteResponse>;
}
